import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function RightArrow({ color = 'currentColor' }) {
    return (_jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, { children: [_jsx("path", { fill: "none", d: "M0 0h24v24H0z" }, void 0), _jsx("path", { d: "M16.01 11H4v2h12.01v3L20 12l-3.99-4z", fill: color }, void 0)] }), void 0));
}
//# sourceMappingURL=right-arrow.js.map